import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function updateContentEssayReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.UPDATE_CONTENT_ESSAY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.UPDATE_CONTENT_ESSAY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.UPDATE_CONTENT_ESSAY_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
